export const setMsgTxt = (MsgText) => (dispatch) => {
  dispatch({ type: "ADD_TXT_MSG", payload: MsgText });
};
